var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SlicesRenderer } from './slices-renderer';
var cls = classNames('entity-view');
export var OnboardingViewDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'OnboardingView',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var OnboardingView = function (props) {
  var componentProps = useComponentProps(My.NAME, OnboardingViewDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    view = componentProps.view;
  // TODO - support ViewLayout. for now though, we can just render all slices inside the view.
  // which will be all we need for most use cases.
  if (view) {
    // loop through the view's slices and render them all.
    return React.createElement(My.Container, {
      className: cls.name(className)
    }, React.createElement(SlicesRenderer, {
      items: view.slices
    }));
  }
  return null;
};
OnboardingView.cls = cls;
var templateObject_1, templateObject_2;